var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { forwardRef } from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import { IconClose } from '@arco-design/iconbox-react-m4b-next';
import { CSSTransition } from 'react-transition-group';
import cx from 'classnames';
import { errorIcon, warningIcon } from './assets/icon';
import './style/banner.less';
import { useControlled } from './hooks/use-controlled';
var AlertBannerRender = function (props, ref) {
    var _a;
    var globalPrefixCls = useConfigContext().prefixCls;
    var style = props.style, className = props.className, wrapperClassName = props.wrapperClassName, action = props.action, _b = props.type, type = _b === void 0 ? 'warning' : _b, title = props.title, content = props.content, icon = props.icon, _c = props.showIcon, showIcon = _c === void 0 ? true : _c, closable = props.closable, afterClose = props.afterClose, onClose = props.onClose, closeElement = props.closeElement;
    var _d = __read(useControlled(props, {
        valuePropName: 'closeVisible',
        onChangePropName: 'onCloseVisible',
        defaultValuePropName: 'defaultCloseVisible',
        defaultValue: true,
    }), 2), closeVisible = _d[0], setCloseVisible = _d[1];
    function renderIcon(type) {
        if (icon) {
            return icon;
        }
        switch (type) {
            case 'warning':
                return warningIcon;
            case 'error':
                return errorIcon;
            default:
                return null;
        }
    }
    function onHandleClose(e) {
        setCloseVisible(false);
        onClose && onClose(e);
    }
    var prefixCls = "".concat(globalPrefixCls, "-alert-banner");
    var classNames = cx(prefixCls, "".concat(prefixCls, "-").concat(type), (_a = {},
        _a["".concat(prefixCls, "-with-title")] = title,
        _a), className);
    var wrapperClassNames = cx("".concat(prefixCls, "-wrapper"), wrapperClassName);
    return (React.createElement(CSSTransition, { in: closeVisible, timeout: 300, classNames: "zoomInTop", unmountOnExit: true, onExited: function () {
            afterClose && afterClose();
        } },
        React.createElement("div", { ref: ref, style: style, className: classNames, role: "alert", "data-tid": "m4b_alert_banner" },
            React.createElement("div", { className: wrapperClassNames },
                React.createElement("div", { className: "".concat(prefixCls, "-content-wrapper") },
                    React.createElement("div", { className: "".concat(prefixCls, "-title-wrapper") },
                        showIcon && React.createElement("div", { className: "".concat(prefixCls, "-icon-wrapper") }, renderIcon(type)),
                        title && React.createElement("div", { className: "".concat(prefixCls, "-title") }, title)),
                    content && React.createElement("div", { className: "".concat(prefixCls, "-content") }, content)),
                React.createElement("div", { className: "".concat(prefixCls, "-action-wrapper") },
                    action && React.createElement("div", { className: "".concat(prefixCls, "-action") }, action),
                    closable && (React.createElement("button", { onClick: onHandleClose, className: "".concat(prefixCls, "-close-btn") }, closeElement || React.createElement(IconClose, null))))))));
};
var AlertBanner = forwardRef(AlertBannerRender);
AlertBanner.displayName = 'Alert.Banner';
export default AlertBanner;
